import styled, { keyframes, css } from 'styled-components';
import conectadosBackground from '../assets/conectados/conectados_background.png';
import backgroundImage from '../assets/images/background.jpg';
import portadaImage from '../assets/recursos/portada-square.png';

// ========================================
// Animations
// ========================================

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

export const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(217, 125, 43, 0.4),
                0 0 0 0 rgba(217, 125, 43, 0.7),
                0 0 0 0 rgba(217, 125, 43, 0.4);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 12px 40px rgba(217, 125, 43, 0.6),
                0 0 0 10px rgba(217, 125, 43, 0),
                0 0 0 20px rgba(217, 125, 43, 0);
  }
`;

export const bounce = keyframes`
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-15px) scale(1.08);
  }
`;

export const glow = keyframes`
  0%, 100% {
    box-shadow: 0 8px 25px rgba(217, 125, 43, 0.4),
                0 0 20px rgba(217, 125, 43, 0.3),
                0 0 40px rgba(217, 125, 43, 0.2);
  }
  50% {
    box-shadow: 0 12px 40px rgba(217, 125, 43, 0.7),
                0 0 30px rgba(217, 125, 43, 0.5),
                0 0 60px rgba(217, 125, 43, 0.3);
  }
`;

export const float3D = keyframes`
  0% {
    transform: translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg) scale(1);
    box-shadow: 0 8px 25px rgba(217, 125, 43, 0.4);
  }
  25% {
    transform: translate3d(2px, -8px, 0) rotateX(2deg) rotateY(-3deg) scale(1.03);
    box-shadow: 0 10px 30px rgba(217, 125, 43, 0.45);
  }
  50% {
    transform: translate3d(0, -12px, 0) rotateX(0deg) rotateY(0deg) scale(1.05);
    box-shadow: 0 12px 35px rgba(217, 125, 43, 0.5);
  }
  75% {
    transform: translate3d(-2px, -8px, 0) rotateX(-2deg) rotateY(3deg) scale(1.03);
    box-shadow: 0 10px 30px rgba(217, 125, 43, 0.45);
  }
  100% {
    transform: translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg) scale(1);
    box-shadow: 0 8px 25px rgba(217, 125, 43, 0.4);
  }
`;

export const auraPulse = keyframes`
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(217, 125, 43, 0.4),
                0 0 0 0 rgba(217, 125, 43, 0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
    box-shadow: 0 0 0 10px rgba(217, 125, 43, 0),
                0 0 0 20px rgba(217, 125, 43, 0);
  }
`;

export const particleFloat = keyframes`
  0% {
    transform: translate3d(0, 0, 0) scale(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  100% {
    transform: translate3d(var(--tx), var(--ty), 0) scale(1);
    opacity: 0;
  }
`;

export const rotateSlow = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const ripple = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
`;

export const ripple2 = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  100% {
    transform: scale(2.8);
    opacity: 0;
  }
`;

export const shine = keyframes`
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
`;

export const slideInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const slideOutDown = keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
`;

// ========================================
// Main Container
// ========================================

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
`;

// ========================================
// Hero Section
// ========================================

export const HeroSection = styled.section`
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(30, 76, 92, 0.85) 0%,
      rgba(217, 125, 43, 0.75) 100%
    );
    z-index: 1;
  }
`;

export const HeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: translate3d(0, ${props => props.$offset * 0.5}px, 0);
  will-change: transform;
  
  @media (max-width: 768px) {
    transform: none;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 2rem;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  animation: ${fadeInUp} 1s ease-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const HeroTitle = styled.h1`
  color: white;
  font-size: clamp(2.5rem, 8vw, 5rem);
  font-weight: 800;
  margin-bottom: 1.5rem;
  text-shadow: 2px 4px 12px rgba(0, 0, 0, 0.3);
  letter-spacing: -1px;
  line-height: 1.1;
`;

export const HeroSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.95);
  font-size: clamp(1.1rem, 3vw, 1.5rem);
  margin-bottom: 3rem;
  text-shadow: 1px 2px 8px rgba(0, 0, 0, 0.2);
  font-weight: 300;
  line-height: 1.6;
`;

export const CTAButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem 3rem;
  background: linear-gradient(135deg, #D97D2B 0%, #F5A64A 100%);
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(217, 125, 43, 0.4);
  border: 2px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(217, 125, 43, 0.6);
    background: linear-gradient(135deg, #F5A64A 0%, #D97D2B 100%);
  }
  
  &:active {
    transform: translateY(-1px);
  }
`;

export const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  animation: ${float} 2s ease-in-out infinite;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ScrollArrow = styled.div`
  width: 30px;
  height: 30px;
  border-left: 3px solid white;
  border-bottom: 3px solid white;
  transform: rotate(-45deg);
  opacity: 0.8;
`;

// ========================================
// Content Sections
// ========================================

export const Section = styled.section`
  padding: 6rem 2rem;
  background: ${props => props.background || '#f5f5f5'};
  animation: ${fadeIn} 0.8s ease-out;
  
  @media (max-width: 768px) {
    padding: 4rem 1.5rem;
  }
`;

export const ResourcesSectionWrapper = styled(Section)`
  background: url(${portadaImage}) center center;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  
  /* Add semi-transparent overlay for better readability */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 0;
  }
  
  /* Ensure content is above the overlay */
  & > * {
    position: relative;
    z-index: 1;
  }
  
  /* Mobile optimizations - disable fixed attachment and improve background */
  @media (max-width: 768px) {
    background-attachment: scroll;
    background: linear-gradient(
      135deg,
      rgba(30, 76, 92, 0.15) 0%,
      rgba(217, 125, 43, 0.1) 50%,
      rgba(30, 76, 92, 0.15) 100%
    ),
    url(${portadaImage}) center center;
    background-size: cover;
    background-position: center;
    
    /* Enhanced overlay for mobile with gradient */
    &::before {
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.75) 0%,
        rgba(255, 255, 255, 0.65) 50%,
        rgba(255, 255, 255, 0.75) 100%
      );
    }
  }
  
  /* Extra small devices - even more subtle background */
  @media (max-width: 480px) {
    background: linear-gradient(
      135deg,
      rgba(30, 76, 92, 0.2) 0%,
      rgba(217, 125, 43, 0.15) 50%,
      rgba(30, 76, 92, 0.2) 100%
    ),
    url(${portadaImage}) center center;
    background-size: cover;
    background-position: center;
    
    &::before {
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0.8) 100%
      );
    }
  }
`;

export const LinksSectionWrapper = styled(Section)`
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: clamp(2rem, 5vw, 3rem);
  color: #1E4C5C;
  margin-bottom: 1rem;
  font-weight: 700;
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  color: #666;
  margin-bottom: 4rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

// ========================================
// Games Section
// ========================================

export const GamesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  justify-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const GameCard = styled.div`
  position: relative;
  background: white;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  text-decoration: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 550px;
  border: 3px solid transparent;
  background-clip: padding-box;
  
  /* Borde con gradiente especial para destacar */
  &::after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    background: linear-gradient(135deg, #D97D2B, #1E4C5C, #D97D2B);
    border-radius: 24px;
    z-index: -1;
    opacity: 0.3;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 60px rgba(217, 125, 43, 0.4);
  }
  
  &:hover::after {
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    max-width: 400px;
  }
  
  @media (max-width: 480px) {
    flex-direction: row;
    max-width: 100%;
  }
`;

export const GameImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${conectadosBackground});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: transform 0.6s ease;
    z-index: 0;
  }
  
  ${GameCard}:hover &::before {
    transform: scale(1.15);
  }
  
  @media (max-width: 768px) {
    height: 180px;
  }
  
  @media (max-width: 480px) {
    width: 130px;
    min-width: 130px;
    height: 100%;
    align-self: stretch;
  }
`;

export const GameImage = styled.img`
  max-width: 70%;
  max-height: 70%;
  object-fit: contain;
  transition: transform 0.5s ease;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  position: relative;
  z-index: 1;
  
  ${GameCard}:hover & {
    transform: scale(1.15) rotate(2deg);
  }
  
  @media (max-width: 480px) {
    max-width: 70%;
    max-height: 70%;
  }
`;

export const GameInfo = styled.div`
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  z-index: 2;
  background: white;
  
  @media (max-width: 768px) {
    padding: 1.25rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.65rem 0.5rem;
    justify-content: center;
  }
`;

export const GameTitle = styled.h3`
  font-size: 1.8rem;
  color: #1E4C5C;
  margin-bottom: 0.5rem;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.2rem;
    margin-bottom: 0.35rem;
  }
`;

export const GameDescription = styled.p`
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  flex: 1;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    line-height: 1.4;
    margin-bottom: 0.5rem;
  }
`;

export const GameBadge = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 50px;
  height: 50px;
  background: #D97D2B;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(217, 125, 43, 0.4);
  transition: all 0.3s ease;
  z-index: 10;
  
  svg {
    color: white;
    font-size: 1.5rem;
  }
  
  ${GameCard}:hover & {
    background: #C06A22;
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 6px 20px rgba(217, 125, 43, 0.5);
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    top: 0.75rem;
    right: 0.75rem;
    
    svg {
      font-size: 1.2rem;
    }
  }
  
  @media (max-width: 480px) {
    width: 35px;
    height: 35px;
    top: 0.5rem;
    right: 0.5rem;
    
    svg {
      font-size: 1rem;
    }
  }
`;

// ========================================
// Footer
// ========================================

export const Footer = styled.footer`
  background: linear-gradient(135deg, #1E4C5C 0%, #143742 100%);
  color: white;
  padding: 3rem 2rem 2rem;
  text-align: center;
`;

export const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

export const SocialLink = styled.a`
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  text-decoration: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  
  &:hover {
    transform: translateY(-3px) scale(1.1);
  }
  
  /* Instagram - gradient with pink shadow */
  &[aria-label="Instagram"]:hover {
    background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
    border-color: #E4405F;
    box-shadow: 0 8px 20px rgba(228, 64, 95, 0.5);
  }
  
  /* Facebook - classic blue with blue shadow */
  &[aria-label="Facebook"]:hover {
    background: #1877F2;
    border-color: #1877F2;
    box-shadow: 0 8px 20px rgba(24, 119, 242, 0.5);
  }
  
  /* TikTok - black with pink shadow */
  &[aria-label="TikTok"]:hover {
    background: #000000;
    border-color: #FE2C55;
    box-shadow: 0 8px 20px rgba(254, 44, 85, 0.5);
  }
  
  /* WhatsApp - green with green shadow */
  &[aria-label="WhatsApp"]:hover {
    background: #25D366;
    border-color: #25D366;
    box-shadow: 0 8px 20px rgba(37, 211, 102, 0.5);
  }
`;

export const FooterText = styled.p`
  font-size: 0.9rem;
  opacity: 0.8;
  margin-top: 1rem;
`;

// ========================================
// Floating Action Button
// ========================================

export const FloatingButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D97D2B 0%, #F5A64A 100%);
  border: 3px solid rgba(255, 255, 255, 0.4);
  cursor: pointer;
  display: none; /* Oculto por defecto (solo mobile) */
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: visible;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
  
  /* Optimización de rendimiento */
  will-change: transform, box-shadow;
  
  /* Animación de entrada/salida */
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transform: ${props => props.$isVisible 
    ? 'translate3d(0, 0, 0) scale(1)' 
    : 'translate3d(0, 20px, 0) scale(0.8)'};
  
  /* Animaciones combinadas cuando está visible - efectos de juego */
  ${props => props.$isVisible 
    ? css`
      animation: ${slideInUp} 0.5s ease-out,
                 ${float3D} 4s cubic-bezier(0.4, 0, 0.6, 1) infinite 0.5s;
    `
    : css`
      animation: ${slideOutDown} 0.4s ease-out;
    `}
  
  /* Aura pulsante alrededor del botón */
  &::after {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(217, 125, 43, 0.3) 0%, transparent 70%);
    ${props => props.$isVisible 
      ? css`
        animation: ${auraPulse} 2s ease-in-out infinite;
      `
      : ''}
    pointer-events: none;
    z-index: -1;
  }
  
  &:hover {
    transform: translateY(-8px) scale(1.15) !important;
    box-shadow: 0 20px 50px rgba(217, 125, 43, 0.6) !important;
    background: linear-gradient(135deg, #F5A64A 0%, #D97D2B 100%);
    border-color: rgba(255, 255, 255, 0.7);
    animation-play-state: paused;
  }
  
  &:active {
    transform: translateY(-4px) scale(1.1) !important;
  }
  
  /* Solo mostrar en mobile */
  @media (max-width: 768px) {
    display: flex;
    width: 56px;
    height: 56px;
    bottom: 1.5rem;
    right: 1.5rem;
  }
  
  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
    bottom: 1rem;
    right: 1rem;
  }
`;

export const FloatingButtonImage = styled.img`
  position: relative;
  z-index: 3;
  width: 140%;
  height: 140%;
  object-fit: contain;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  
  ${FloatingButton}:hover & {
    transform: rotate(10deg) scale(1.2);
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  }
`;

export const FloatingButtonRipple = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, transparent 70%);
  transform: translate(-50%, -50%) scale(0.8);
  animation: ${ripple} 2s ease-out infinite;
  pointer-events: none;
  z-index: 1;
`;

export const FloatingButtonRipple2 = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  transform: translate(-50%, -50%) scale(0.9);
  animation: ${ripple2} 2.5s ease-out infinite 0.5s;
  pointer-events: none;
  z-index: 0;
`;

export const ParticleContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200%;
  height: 200%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 1;
`;

export const Particle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.9) 0%, rgba(217, 125, 43, 0.6) 100%);
  border-radius: 50%;
  --tx: ${props => Math.cos(props.$angle * Math.PI / 180) * 40}px;
  --ty: ${props => Math.sin(props.$angle * Math.PI / 180) * 40}px;
  animation: ${particleFloat} 2s ease-in-out infinite;
  animation-delay: ${props => props.$delay}s;
  box-shadow: 0 0 6px rgba(217, 125, 43, 0.8);
  will-change: transform, opacity;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
`;

